import { useEffect, useState } from "react";
import Header from "./Header";
import free from "./Assets/certificates/free.png";
import foundation from "./Assets/certificates/foundation.png";
import start from "./Assets/certificates/start.png";
import build from "./Assets/certificates/build wireframe.png";
import conductUx from "./Assets/certificates/conduct research.jpeg";
import createHigh from "./Assets/certificates/high fidelity.jpeg";
import dynamic from "./Assets/certificates/Build User Interfaces (UI) for Websites.jpeg";
import ux from "./Assets/certificates/Google UX Design.jpeg";
import uxBadge from "./Assets/certificates/GCC_badge_UX_1000x1000.png";
import foundationPm from "./Assets/certificates/Foundations of Project Management.jpeg";
import projectIni from "./Assets/certificates/Project Initiation.jpeg";
import projectPlan from "./Assets/certificates/Project Planning.jpeg";
import projectExec from "./Assets/certificates/Project Execution.jpeg";
import agile from "./Assets/certificates/Agile Project Management .jpeg";
import gpm from "./Assets/certificates/Google Project Management.jpeg";
import gpB from "./Assets/certificates/GCC_badge_PGM_1000x1000.png";
import altSchool from "./Assets/certificates/altschool.png";
import udemy from "./Assets/certificates/udemy.jpg";
import Footer from "./Footer";

const certificates = [
  {
    id: 18,
    title: "The Ultimate React Course 2023: React, Redux & More",
    issuer: "Udemy",
    pic: udemy,
    date: "October 9 2023",
    link: "https://www.udemy.com/certificate/UC-4b7c99b9-1f7c-4d99-ac2d-efa4094cbdb4/",
  },
  {
    id: 17,
    title: "Frontend Engineering",
    issuer: "AltSchool Africa",
    pic: altSchool,
    date: "November 10, 2023",
    link: null,
  },
  {
    id: 16,
    title: "Google Project Management Certificate",
    issuer: "Google",
    pic: gpB,
    date: "June 08, 2023",
    link: "https://www.credly.com/badges/e80f8552-ceec-4cf5-82e8-6042d198d9de/linked_in_profile",
  },
  {
    id: 15,
    title: "Google Project Management",
    issuer: "Google",
    pic: gpm,
    date: "June 8, 2023",
    link: "https://www.coursera.org/account/accomplishments/specialization/certificate/A2NGHZ7N2VTD",
  },
  {
    id: 14,
    title: "Agile Project Management",
    issuer: "Google",
    pic: agile,
    date: "April 25, 2023",
    link: "https://www.coursera.org/account/accomplishments/certificate/UPS83DW4KPGY",
  },
  {
    id: 13,
    title: "Project Execution: Running the Project",
    issuer: "Google",
    pic: projectExec,
    date: "March 24, 2023",
    link: "https://www.coursera.org/account/accomplishments/certificate/3M2W8ZL69W5G",
  },
  {
    id: 12,
    title: "Project Planning: Putting It All Together",
    issuer: "Google",
    pic: projectPlan,
    date: "February 12, 2023",
    link: "https://www.coursera.org/account/accomplishments/certificate/PJ6Y2VCMR9NZ",
  },
  {
    id: 11,
    title: "Project Initiation: Starting a Successful Project",
    issuer: "Google",
    pic: projectIni,
    date: "January 2, 2023",
    link: "https://www.coursera.org/account/accomplishments/certificate/MS2QTQVP8XYS",
  },
  {
    id: 10,
    title: "Foundations of Project Management",
    issuer: "Google",
    pic: foundationPm,
    date: "December 1, 2022",
    link: "https://www.coursera.org/account/accomplishments/certificate/MS2QTQVP8XYS",
  },
  {
    id: 9,
    title: "Google UX Design Professional Certificate",
    issuer: "Google",
    pic: uxBadge,
    date: "November 11, 2022",
    link: "https://www.credly.com/badges/5e74ad8a-4866-4066-ac7f-4fec4169f2a6/linked_in_profile",
  },
  {
    id: 8,
    title: "Google UX Design",
    issuer: "Google",
    pic: ux,
    date: "November 11, 2022",
    link: "https://www.coursera.org/account/accomplishments/specialization/certificate/L6JHVZ6LV3AC",
  },
  {
    id: 7,
    title: "Build Dynamic User Interfaces (UI) for Websites",
    issuer: "Google",
    pic: dynamic,
    date: "October 10, 2022",
    link: "https://www.coursera.org/account/accomplishments/certificate/GRT77SGVG63L",
  },
  {
    id: 6,
    title: "Create High-Fidelity Designs and Prototypes in Figma",
    issuer: "Google",
    pic: createHigh,
    date: "September 12, 2022",
    link: "https://www.coursera.org/account/accomplishments/certificate/63X454FGR68K",
  },
  {
    id: 5,
    title: "Conduct UX Research and Test Early Concepts",
    issuer: "Google",
    pic: conductUx,
    date: "August 19, 2022",
    link: "https://www.coursera.org/account/accomplishments/certificate/PVLR2HXVX6JR",
  },
  {
    id: 4,
    title: "Build Wireframes and Low-Fidelity Prototypes",
    issuer: "Google",
    pic: build,
    date: "July 30, 2022",
    link: "https://coursera.org/share/9a30132b2f44eb1c1b5c94d50475de01",
  },
  {
    id: 3,
    title: "Start the UX Design Process: Empathize, Define, and Ideate ",
    issuer: "Google",
    pic: start,
    date: "July 7, 2022",
    link: "https://coursera.org/share/af047e59ca52bfa4bc9dabcf15fd2996",
  },
  {
    id: 2,
    title: "Foundations of User Experience (UX) Design ",
    issuer: "Google",
    pic: foundation,
    date: "June 11th 2022",
    link: "https://coursera.org/share/bf8c801c87becd3e5810c02211112772",
  },
  {
    id: 1,
    title: "Responsive Web Design ",
    issuer: "FreeCodeCamp",
    pic: free,
    date: "May 13th 2022",
    link: "https://www.freecodecamp.org/certification/candyij/responsive-web-design",
  },
];
function Certification() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const savedMode = localStorage.getItem("theme");
    const systemPreference = window.matchMedia("(prefers-color-scheme: dark)").matches;
    if (savedMode === "dark" || (!savedMode && systemPreference)) {
      document.documentElement.classList.add("dark");
      setDarkMode(true);
    }
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  };
  return (
    <>
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className=" w-full flex justify-center items-center h-fit pt-[128px] pb-[48px] 100:px-6 md:px-[64px]">
        <div className="100:w-full 2xl:w-[1312px] flex-col justify-start items-center gap-12 inline-flex">
          <div className=" w-full  p-2.5 flex-col justify-center items-center gap-3 flex">
            <h1 className={`self-stretch ${darkMode ? "text-[#F5F6F6]" : "text-[#393c40]"} 100:text-3xl text-center md:text-5xl font-semibold font-inter`}>Professional Certifications</h1>
          </div>
          <div className="flex-wrap w-full p-2.5 justify-start items-start gap-6 inline-flex">
            {certificates.map((certificate, index) => (
              <div
                key={certificate.id}
                style={{
                  animationDelay: `${index * 0.2}s`,
                  backgroundColor: darkMode ? "rgba(26, 27, 28, 100)" : "rgba(255, 255, 255, 1)", // Dynamic background color
                }}
                className={` card 100:w-full lg:w-[408px] 100:h-fit flex-grow lg:h-[516px] p-6 ${darkMode ? "bg-white/70 border border-white/60" : "bg-white/80"} rounded-2xl shadow flex-col justify-between items-center gap-6 inline-flex`}
              >
                <img className=" flex-1 w-full h-[251px] bg-center object-contain" src={certificate.pic} alt={certificate.title} />

                <div className=" w-full flex-col justify-start items-start gap-4 inline-flex">
                  <div className=" flex-col justify-start items-start gap-2 inline-flex">
                    <h3 className={`w-full ${darkMode ? "text-[#e4e7e9]" : "text-[#393c40]"} text-xl font-medium font-inter`}>{certificate.title}</h3>
                    <h4 className={`${darkMode ? "text-[#a9b2b7]" : "text-[#637077]"} text-sm font-medium font-inter leading-snug`}>{certificate.issuer}</h4>
                  </div>
                  <div
                    className={` w-fit h-6 px-4 py-1.5 ${
                      darkMode ? "bg-[#25282b] text-[#e4e7e9] border-[#e4e7e9]" : "bg-[#f5f6f6] text-[#637077] border-[#a9b2b7]"
                    } rounded-2xl shadow border  justify-center items-center gap-2.5 inline-flex  text-[10px] font-medium font-inter `}
                  >
                    {certificate.date}
                  </div>
                </div>
                <a className=" w-full" href={certificate.link}>
                  <button className={`h-[43px] px-6 py-[5px] w-full  hover:bg-[#fd992f] text-[#25282b] text-base font-medium font-inter  bg-[#ffb600] rounded-3xl shadow-customWhite justify-center items-center gap-2.5 inline-flex`}>
                    Certificate Link
                  </button>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer darkMode={darkMode} />
    </>
  );
}

export default Certification;
